import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { InvoiceTemplateRow } from "../invoiceTemplates.types";
import { TemplateDateCell } from "./TemplateDateCell";

export const CreatedCell = memo(function CreatedCell({
    row,
}: CellContext<ViewTableFeatures, InvoiceTemplateRow, Date>) {
    return <TemplateDateCell value={row.original.createdAt} />;
});
